import React from "react"
import { Grid, Card, Button } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { cardTypes } from "./cardTypes"

export const CardGroup = ({
  items,
  addCardLabel,
  addCardLink,
  cardType,
  baseUrl,
  itemsPerRow,
  ...rest
}) => {
  const cards = items.map(item => {
    const CardType = cardTypes[cardType]
    return <CardType {...item} key={item.id} baseUrl={baseUrl} />
  })
  return (
    <Grid.Row {...rest}>
      <Grid.Column>
        <Card.Group
          itemsPerRow={itemsPerRow}
          style={{ display: itemsPerRow === 1 ? "inline-block" : "flex" }}
        >
          {cards}
          {addCardLabel && <AddCard label={addCardLabel} link={addCardLink} />}
        </Card.Group>
      </Grid.Column>
    </Grid.Row>
  )
}

const AddCard = ({ label, link }) => (
  <Card className="AddCard">
    <Card.Content className="AddCard__Content">
      <Grid verticalAlign="middle" className="AddCard__Grid">
        <Grid.Row textAlign="center">
          <Grid.Column>
            <Link to={link}>
              <Button primary>{label}</Button>
            </Link>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)

CardGroup.defaultProps = {
  itemsPerRow: 2
}
